import { auth } from './firebase';

const API_BASE = process.env.REACT_APP_API_URL || 'https://web-api-irnuiiphsq-uc.a.run.app';

async function getHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  const user = auth.currentUser;
  if (user && !user.isAnonymous) {
    try {
      const token = await user.getIdToken();
      headers['Authorization'] = `Bearer ${token}`;
    } catch (err) {
      console.warn('[API] Failed to get ID token:', err.message);
    }
  }
  return headers;
}

async function apiRequest(path, options = {}) {
  const headers = await getHeaders();
  const url = `${API_BASE}${path}`;
  let res;
  try {
    res = await fetch(url, { ...options, headers: { ...headers, ...options.headers } });
  } catch (err) {
    console.error(`[API] Network error: ${err.message}`, { url, user: auth.currentUser?.uid, isAnon: auth.currentUser?.isAnonymous });
    throw new Error(`Network error: ${err.message}`);
  }
  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`API returned non-JSON (status ${res.status})`);
  }
  if (!res.ok) {
    console.error(`[API] Error ${res.status}:`, data);
    throw new Error(data.error || `API error ${res.status}`);
  }
  return data;
}

export function apiGet(path) {
  return apiRequest(path);
}

export function apiPost(path, body) {
  return apiRequest(path, { method: 'POST', body: JSON.stringify(body) });
}

export function apiPut(path, body) {
  return apiRequest(path, { method: 'PUT', body: JSON.stringify(body) });
}

export function apiPatch(path, body) {
  return apiRequest(path, { method: 'PATCH', body: JSON.stringify(body) });
}
